export default {"src":"/_next/static/media/businessScheduler.05896b4d.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};